interface ApplyMinMaxArgs {
  value: number;
  min?: number;
  max?: number;
}

export const applyMinMax = ({ value, min = 0, max = 1 }: ApplyMinMaxArgs): number => {
  if (value > max) return max;
  if (value < min) return min;
  return value;
};
